import { request } from '@/utils/ajax';
import { memoize } from 'lodash-es';
import { Currency } from '@/types';

export const getCurrencies = memoize(
    (): Promise<Currency[]> => {
        return request(`api/currency`).then((x) => x.json());
    }
);
